import createListDataFetchManagementStoreSlice from '../../../modules/utilities/store/slices/listDataFetchManagement'

const sliceName = 'deviceManagementExperience.listExport'

const DeviceManagementDeviceListExportSlice = createListDataFetchManagementStoreSlice(
  sliceName
)

export default DeviceManagementDeviceListExportSlice
